import React from "react";
import { Select, Radio } from "antd";
import { SupportLanguages } from "../../i18n";
import { isFunction } from "../../util";

class LagnaugeSelection extends React.Component{
    state = { selectLagnauge: "en" }
    constructor(props){
    	super(props);
    	const { selectLagnauge } = props;
    	this.state.selectLagnauge = selectLagnauge || "en";
    }
    onLangChanged = (e)=>{
    	const { onChanged } = this.props;
    	this.setState({selectLagnauge:e.target.value}, 
    		isFunction(onChanged) ? ()=>{onChanged(e.target.value);} : undefined);
    }
    render(){
    	// Set asRatio as true to make it render as RadioGroup instead of selection. 
    	const { selectLagnauge } = this.state;
    	const langs = Object.keys(SupportLanguages);
    	if(langs.length < 4){
    		return <Radio.Group value={selectLagnauge} onChange={this.onLangChanged}>
    			{langs.map((lng,index)=>(<Radio.Button key={index} value={lng}>
    				{SupportLanguages[lng]}
    			</Radio.Button>))}
    		</Radio.Group>;
    	}
    	return <Select defaultValue={selectLagnauge} onChange={this.onLangChanged}>
    		{langs.map((lng,index)=>(<Select.Option key={index} value={lng}>
    			{SupportLanguages[lng]}
    		</Select.Option>))}
    	</Select>;
    }
}
LagnaugeSelection.defaultProps = {
	selectLagnauge:"en",
	onChanged: (lng)=>{}
};
export default LagnaugeSelection;


// WEBPACK FOOTER //
// ./src/components/button/LanguageSelection.js